module.exports = __webpack_public_path__ + "img/vertical_6_4_5010.473f9009.png";